// initialize angular module "app"
angular.module('app', ['ngAnimate', 'ngTouch', 'ngRoute', 'cgBusy', 
                       'ngResource', 'ngCookies', 'sticky', 'angular-inview', 
                       'duScroll', 'angular-gestures', 'ui.bootstrap', 'angular-spinkit', 
                       'app.templates', 'app.directives', 'app.controllers', 'app.services', 
                       'bootstrapLightbox', 'ngAria', 'ngMessages', 'ui.mask'])
  .constant('appConstants', {
    captchaRequired: window.location.href.indexOf("localhost") != 7,
    patterns: {
        allowedChars: /^[A-z0-9-'.,\!\+\(\)\/ ]+$/,
        allowedCharsSpanish: /^[A-z0-9\u00E0-\u00FC\u00C0-\u00DC-'.,\!\+\(\)\/ ]+$/,
        commentsChars: /^[A-z0-9-'.,?\$\!\+\(\)\/\r\n ]+$/,
        commentsCharsSpanish: /^[A-z0-9\u00E0-\u00FC\u00C0-\u00DC-'.,?\$\!\+\(\)\/\r\n\;\@\#\"\:\% ]+$/,
        addressChars: /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/,
        onlyNumbers: /^([0-9]*)$/,
        validDateMDY: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
        validDateMDYNoSlash: /^(0[1-9]|1[0-2])(0[1-9]|1\d|2\d|3[01])(19|20)\d{2}$/,
        validEmail: /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i
    },
    version: '.i'
  })
  .value('uiMaskConfig', {
    maskDefinitions: {
                '9': /\d/,
                'A': /[a-zA-Z]/,
                '*': /[a-zA-Z0-9]/
            },
    clearOnBlur: false,
    clearOnBlurPlaceholder: false,
    escChar: '\\',
    eventsToHandle: ['input', 'keyup', 'click', 'focus'],
    addDefaultPlaceholder: true,
    allowInvalidValue: false
  })
  .config(['$locationProvider', '$routeProvider', '$logProvider', 'LightboxProvider', function ($locationProvider, $routeProvider, $logProvider, LightboxProvider) {
    'use strict';

    $locationProvider.html5Mode(false);
    var TEMPLATE_URL = 'templates/';
    // dynamically route excluding several custom template controllers
    $routeProvider
      .when('/safety', {
        templateUrl: TEMPLATE_URL + 'safety.html',
        controller: 'SafetyController',
        reloadOnSearch: false
      })
      .when('/residential', {
        templateUrl: TEMPLATE_URL + 'residential.html',
        controller: 'ResidentialController',
        reloadOnSearch: false
      })
      .when('/history', {
        templateUrl: TEMPLATE_URL + 'history.html',
        controller: 'HistoryController',
        reloadOnSearch: false
      })
      .when('/rebates-and-promotions', {
        templateUrl: TEMPLATE_URL + 'rebates-and-promotions.html',
        controller: 'RebatesAndPromotionsController',
        reloadOnSearch: true
      })
      .when('/rebates-detail', {
        templateUrl: TEMPLATE_URL + 'rebates-and-promotions-detail.html',
        controller: 'RebatesDetailController',
        reloadOnSearch: true
      })
      .when('/contractor-referral', {
        templateUrl: TEMPLATE_URL + 'contractor-referrals.html',
        controller: 'ContractorReferralController',
        reloadOnSearch: true
      })
      .when('/referral_results', {
        templateUrl: TEMPLATE_URL + 'contractor-referrals-results.html',
        controller: 'ReferralResultsController',
        reloadOnSearch: true
      })
      .when('/understanding-bill', {
        templateUrl: TEMPLATE_URL + 'understanding-bill.html',
        controller: 'UnderstandingBillController',
        reloadOnSearch: false
      })
      .when('/faqs', {
        templateUrl: TEMPLATE_URL + 'faqs.html',
        controller: 'FaqsController',
        reloadOnSearch: false
      })
      .when('/contact', {
        templateUrl: TEMPLATE_URL + 'contact.html',
        controller: 'ContactController',
        reloadOnSearch: false
      })
      .when('/find-a-builder', {
        templateUrl: TEMPLATE_URL + 'find-a-builder.html',
        controller: 'FindABuilderController',
        reloadOnSearch: false
      })
      .when('/material-specification', {
        templateUrl: TEMPLATE_URL + 'material-specification.html',
        controller: 'MaterialSpecificationController',
        reloadOnSearch: false
      })
      .when('/how-rates-set', {
        templateUrl: TEMPLATE_URL + 'how-rates-set.html',
        controller: 'HowRatesSetController',
        reloadOnSearch: false
      })



      /// Paginated (Search) Forms routes
      .when('/news-corporate', {
        templateUrl: TEMPLATE_URL + 'news-corporate.html',
        controller: 'CorporateNewsController', /*'NewsReleasesController',*/
        reloadOnSearch: true
      })
      .when('/news-events', {
        templateUrl: TEMPLATE_URL + 'news-events.html',
        controller: 'NewsEventsController',
        reloadOnSearch: true
      })
      .when('/news-in-the-news', {
        templateUrl: TEMPLATE_URL + 'news-in-the-news.html',
        controller: 'NewsInTheNewsController',
        reloadOnSearch: true
      })
      .when('/news-newsletter', {
        templateUrl: TEMPLATE_URL + 'news-newsletter.html',
        controller: 'NewsLetterController',
        reloadOnSearch: true
      })
      .when('/rebates', {
        templateUrl: TEMPLATE_URL + 'forms/rebates.html',
        controller: 'RebatesController',
        reloadOnSearch: true
      })
      .when('/events', {
        templateUrl: TEMPLATE_URL + 'forms/events.html',
        controller: 'EventsController',
        reloadOnSearch: true
      })


      /// Rates and Tariffs routes
      .when('/arizona-rates-landing', {
        templateUrl: TEMPLATE_URL + 'rates/arizona-rates-and-regulations-home.html',
        controller: 'ArizonaRatesLandingController',
        reloadOnSearch: true
      })
      .when('/california-rates-landing', {
        templateUrl: TEMPLATE_URL + 'rates/california-rates-regulations-landing.html',
        controller: 'CaliforniaRatesLandingController',
        reloadOnSearch: true
      })
      .when('/nevada-rates-landing', {
        templateUrl: TEMPLATE_URL + 'rates/nevada-rates-and-regulations-home.html',
        controller: 'NevadaRatesLandingController',
        reloadOnSearch: true
      })
      .when('/mobile-home', {
        templateUrl: TEMPLATE_URL + 'rates/mobile-home-park-utility-upgrade-program.html',
        controller: 'MobilehomeParkUtilityController',
        reloadOnSearch: true
      })
      .when('/california-advice-letters', {
        templateUrl: TEMPLATE_URL + 'rates/california-advice-letters.html',
        controller: 'CaliforniaAdviceLettersController',
        reloadOnSearch: true
      })
      .when('/nevada-advice-letters', {
        templateUrl: TEMPLATE_URL + 'rates/nevada-advice-letters.html',
        controller: 'NevadaAdviceLettersController',
        reloadOnSearch: true
      })

      .when('/decoupling', {
        templateUrl: TEMPLATE_URL + 'rates/decoupling-and-energy-efficiency-enabling.html',
        controller: 'DecouplingAndEnergyController',
        reloadOnSearch: true
      })


      /// Non-paginated Forms routes
      .when('/email-us-form', {
        templateUrl: TEMPLATE_URL + 'forms/emailUs.html',
        controller: 'EmailUsController',
        reloadOnSearch: true
      })
      .when('/esap-request-form', {
        templateUrl: TEMPLATE_URL + 'forms/esaprequest.html',
        controller: 'EsapController',
        reloadOnSearch: true
      })
      .when('/esap-request-spanish-form', {
        templateUrl: TEMPLATE_URL + 'forms/esaprequest_spanish.html',
        controller: 'EsapControllerSpanish',
        reloadOnSearch: true
      })
      .when('/historic-form', {
        templateUrl: TEMPLATE_URL + 'forms/historic.html',
        controller: 'HistoricController',
        reloadOnSearch: true
      })
      .when('/information-request-form', {
        templateUrl: TEMPLATE_URL + 'forms/informationRequest.html',
        controller: 'InformationRequestController',
        reloadOnSearch: true
      })
      .when('/landlord-agreement-form', {
        templateUrl: TEMPLATE_URL + 'forms/landlordAgreement.html',
        controller: 'LandlordAgreementController',
        reloadOnSearch: true
      })
      .when('/referral-feedback-form', {
        templateUrl: TEMPLATE_URL + 'forms/referralFeedback.html',
        controller: 'ReferralFeedbackController',
        reloadOnSearch: true
      })
      .when('/supplier-profile-form', {
        templateUrl: TEMPLATE_URL + 'forms/supplierProfile.html',
        controller: 'SupplierController',
        reloadOnSearch: true
      })
      .when('/supplier-attachment-form', {
        templateUrl: TEMPLATE_URL + 'forms/SupplierProfileAttachment.html',
        controller: 'SupplierAttachmentController',
        reloadOnSearch: true
      })
      
      // Home page and named pages
      .when('/', {
        templateUrl: TEMPLATE_URL + 'home.html',
        controller: 'HomeController',
        reloadOnSearch: true
      })
      .when('/home', {
        templateUrl: TEMPLATE_URL + 'home.html',
        controller: 'HomeController',
        reloadOnSearch: true
      })
      .when('/:page*', {
        templateUrl: function (params) {
          return TEMPLATE_URL + params.page + '.html';
        },
        controller: 'MasterController',
        reloadOnSearch: true
      });

    LightboxProvider.getImageUrl = function (imageUrl) {
      return imageUrl;
    };

    $logProvider.debugEnabled(false);
  }])
  .run(function ($rootScope, $log, $window, $timeout, $http, SessionService, Lightbox) {

    'use strict';

    var origin;

    // create a new WOW.js instance
    new WOW().init();

    // route change event
    $rootScope.$on('$routeChangeStart', function (next, current) {
      // when the view changes sync wow
      new WOW().sync();
    });


    $log.debug('window.location.origin:', window.location.origin);

    // set BASEURL
    if (window.location.origin === 'http://localhost:8000') {
      origin = 'http://localhost:8000/#'; //'/#';
    } else if (window.location.origin === 'http://plinteractive.github.io') {
      origin = 'http://plinteractive.github.io/swg_wcm_project/#';
    } else {
      origin = window.location.origin;
    }
    $log.debug('app(): origin:', origin);

    $rootScope.BASE_URL = function (route) {
      return origin + route;
    };

    $rootScope.goTo = function (path) {
      window.location = path;
      angular.element($('.sticky-menu')).scope().setupSticky();
    };

    $rootScope.openLightbox = function(image) {
      var arr = [image];
      Lightbox.openModal(arr,0);
    };

    // initialize sessions
    SessionService.init();

    $timeout(function() {
      angular.element('#detail-pane table:not([class])').each(function(){
        var helpMessage = '<div class="ar"><span class="hidden-md hidden-lg">*scroll or swipe ' + 
          'left/right to view the entire table below if not fully visible.</span></div>';
        $(this).addClass('table')
            .before(helpMessage);
        $(this).wrap('<div class="table-responsive"></div>');
      });
    });
  });
